
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.34591',
  depVersions: {
  "documents-public-ui": "static-1.34591",
  "atom": "static-1.5104",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2528",
  "client-types": "static-1.469",
  "cssUtils": "static-1.798",
  "customer-data-filters-ui": "static-1.39902",
  "customer-data-objects": "static-1.7703",
  "customer-data-property-utils": "static-1.8121",
  "documents-lib": "static-1.34596",
  "emoji-mart": "static-3.4",
  "flux-actions": "static-1.341",
  "FormsCommonComponents": "static-1.85933",
  "FormUrlGenerator": "static-2.4749",
  "foundations-theming-specialty": "static-1.2166",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.5007",
  "highcharts": "static-8.104",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5621",
  "hs-test-utils": "static-1.8045",
  "hub-http": "static-1.6253",
  "hubspot-dlb": "static-2.1854",
  "HubStyle": "static-2.11810",
  "HubStyleTokens": "static-2.11503",
  "I18n": "static-7-hdineen_hubspot-i18n-react-compiler.2",
  "icons": "static-2.650",
  "jasmine-immutable": "static-1.3051",
  "jasmine-runner": "static-1.6494",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.7186",
  "lodash": "static-1.3",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "property-translator": "static-1.5429",
  "quartz": "static-1.7068",
  "react": "static-7.186",
  "react-dlb": "static-1.79",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.71",
  "react-rhumb": "static-1.16704",
  "react-select-plus": "static-1.105",
  "react-utils": "static-2.5368",
  "react-virtualized": "static-2.99",
  "reference-resolvers": "static-1.8202",
  "reference-resolvers-lite": "static-1.8125",
  "reporting-data": "static-1.67681",
  "reporting-reports": "static-1.67359",
  "reporting-snowflake": "static-1.56299",
  "reporting-testing-lib": "static-1.9614",
  "reporting-visualizations": "static-1.59757",
  "reselect": "static-2.16",
  "sales-content-partitioning": "static-1.8973",
  "sanitize": "static-1.4506",
  "sanitize-text": "static-1.8173",
  "self-service-api": "static-1.10278",
  "SharedI18nStrings": "static-1.182",
  "SharedLegalStrings": "static-1.1778",
  "signup-constants": "static-1.18900",
  "signup-ui-url-generator": "static-2.8083",
  "StyleGuideUI": "static-3.487",
  "superstore": "static-1.4791",
  "tinymce": "static-6.5",
  "transmute": "static-2.85",
  "ui-addon-draggable": "static-3.4793",
  "ui-addon-form-validation": "static-1.11020",
  "ui-asset-management-lib": "static-1.11076",
  "ui-images": "static-2.1160",
  "UIComponents": "static-3.8449",
  "usage-tracker": "static-1.7378",
  "usage-tracker-container": "static-1.7368",
  "usage-tracker-core": "static-1.7228",
  "viral-links-lib": "static-1.7097",
  "webpack-env": "static-1.54",
  "data-fetching-client": "static-1.9697",
  "foundations-components": "static-1.7993",
  "immutable": "static-2.79",
  "isMobile": "static-1.7",
  "PortalIdParser": "static-2.404",
  "quartz-config": "static-1.846",
  "quartz-core": "static-1.6287",
  "quick-fetch": "static-1.3940",
  "raven": "static-3.5925",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "rpc-client-utils": "static-1.4683",
  "ui-addon-i18n": "static-1.11179",
  "ui-addon-upgrades": "static-9.18040",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4132",
  "metrics-js": "static-1.9637",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3423",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3345",
  "quartz-webpack": "static-1.3292",
  "foundations-assets": "static-1.4899",
  "foundations-theming": "static-1.4450",
  "hub-http-shared-msw-handlers": "static-1.10033",
  "hubspotter-http": "static-1.4675",
  "sassPrefix": "static-1.156",
  "events-data-lib": "static-1.255",
  "conversations-skeleton-state": "static-1.7278",
  "crm-message-bus": "static-1.43043",
  "customer-data-filters-ui-msw-helpers": "static-1.22337",
  "customer-data-objects-ui-components": "static-1.13059",
  "customer-data-reference-ui-components": "static-1.13197",
  "customer-data-ui-utilities": "static-1.9856",
  "framework-builder-read-service-client": "static-1.4029",
  "framework-data-schema-quick-fetch": "static-1.6821",
  "framework-data-schema-resolvers": "static-1.6916",
  "inbound-db-meta-service-client": "static-1.3610",
  "inbound-db-properties-service-client": "static-1.3870",
  "multi-account-reference-resolvers": "static-1.1010",
  "onboarding-tours": "static-1.16669",
  "reporting-datasets-permissions-lib": "static-1.13766",
  "ui-addon-teams": "static-1.21598",
  "quartz-auth": "static-1.743",
  "ui-business-units-lib": "static-1.9086",
  "usage-tracker-session-replay": "static-1.5064",
  "ai-components-ui-library": "static-1.9045",
  "ContentUtils": "static-1.68451",
  "customer-data-properties": "static-1.51668",
  "forms-ai-lib": "static-1.4362",
  "forms-utils-lib": "static-1.12639",
  "foundations-components-test-utils": "static-1.5476",
  "react-dnd-compat": "static-1.4645",
  "react-tinymce": "static-1.55325",
  "tinymce-config": "static-2.54451",
  "ui-gdpr-components": "static-1.10381",
  "underscore": "static-1.8",
  "foundations-theming-base": "static-1.3435",
  "HeadJS": "static-2.764",
  "framer-motion": "static-1.72",
  "hs-test-utils-bend-plugin": "static-1.3156",
  "msw": "static-1.39",
  "testing-library": "static-1.152",
  "hs-locale-management": "static-1.104",
  "ui-fonts": "static-1.765",
  "i18n-data": "static-1.221",
  "moment-timezone": "static-5.83",
  "jasmine": "static-4.4357",
  "csstype": "static-1.50",
  "quartz-head": "static-1.733",
  "web-vitals": "static-1.6",
  "batch-promise": "static-1.1572",
  "external-options-client-types": "static-1.4183",
  "fast-json-stable-stringify": "static-1.4",
  "quartz-i18n": "static-1.743",
  "frontend-preferences-client": "static-1.7957",
  "graphql": "static-1.82",
  "immer": "static-1.33",
  "persist-promise": "static-1.3729",
  "reporting-client-types": "static-1.2506",
  "apollo-stack-hubspot": "static-3.86",
  "growth-payments-core": "static-1.25461",
  "hubspot-apollo-client": "static-1.4909",
  "foundations-components-legacy": "static-1.1018",
  "merchandise-lib": "static-1.264",
  "quartz-routing": "static-1.498",
  "hs-story-utils": "static-1.9454",
  "react-flip-move": "static-1.70",
  "nested-table": "static-1.257",
  "timezone-utils": "static-2.5275",
  "seat-types-lib": "static-1.79",
  "bend-plugin-foundations-components": "static-1.4262",
  "floating-ui": "static-1.56",
  "react-aria": "static-1.66",
  "react-create-root-preference": "static-1.29",
  "tanstack-table": "static-1.55",
  "trellis-assets": "static-1.2035",
  "dispatcher": "static-1.137",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.838",
  "mobile-manifest-mixins": "static-1.538",
  "module-federation": "static-1.23",
  "quartz-test": "static-1.743",
  "quartz-tracking": "static-1.447",
  "bend-plugin-chirp-manifest": "static-1.93",
  "chirp-fetch": "static-1.1918",
  "purchase-motions-components": "static-1.5973",
  "salesImages": "static-1.525",
  "ts-schema": "static-1.4104",
  "bender-build-tools": "static-1.3227",
  "bend-plugin-foundations-theming": "static-1.2933",
  "stylex": "static-1.33",
  "hs-resources": "static-1.187",
  "pulse": "static-1.611",
  "restore-request-side-panel-lib": "static-1.978",
  "react-immutable-render-mixin": "static-1.9",
  "conditional-properties-service-client": "static-1.3821",
  "crm-pipelines-api-client-types": "static-1.4163",
  "fdsr-migration-layer": "static-1.35",
  "multi-currency-client-types": "static-1.3715",
  "getting-started-shared-tasks": "static-1.18529",
  "growth-data-modal": "static-1.5473",
  "growth-onboarding-confetti": "static-1.3097",
  "growth-onboarding-next-action-utils": "static-1.2003",
  "navigation-components": "static-1.18115",
  "onboarding-tours-client": "static-1.4883",
  "onboarding-tours-utils": "static-1.735",
  "ui-shepherd-react": "static-3.10202",
  "ui-shepherd-tracker": "static-1.7583",
  "ui-universal-auth": "static-1.9014",
  "user-context": "static-1.5136",
  "hubspotter-http-shared-msw-handlers": "static-1.10031",
  "magpie-lib": "static-1.5571",
  "navigation-messaging": "static-1.7442",
  "amplitude-session-replay-browser": "static-1.60",
  "chatspot-core": "static-1.21415",
  "copilot-toolkit": "static-1.11208",
  "cms-field-types": "static-1.4843",
  "content-icons-ui": "static-1.2233",
  "integrations-lib": "static-1.16251",
  "calling-global-api": "static-1.64613",
  "calling-internal-common": "static-1.31333",
  "calling-lifecycle-internal": "static-1.65995",
  "calling-lifecycle-messages": "static-1.58289",
  "commerce-products-lib": "static-1.9672",
  "crm-links": "static-1.6326",
  "customer-data-properties-shared-msw-handlers": "static-1.9360",
  "file-manager-components": "static-1.23701",
  "google-libphonenumber": "static-1.38",
  "inbounddb-objects-service-types": "static-1.4247",
  "meetings-icalendar-utils-lib": "static-1.662",
  "object-builder-ui-client": "static-1.48841",
  "pipeline-validation-client-types": "static-1.3989",
  "property-value-citations": "static-1.2282",
  "smart-property-lib": "static-1.7237",
  "tiered-pricing": "static-1.1282",
  "zustand": "static-1.74",
  "ui-addon-iframeable": "static-1.9091",
  "final-form": "static-1.70",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.19882",
  "tinymce-themes": "static-1.56421",
  "data-token-picker": "static-1.16457",
  "hub-http-contrib": "static-1.3072",
  "interframe": "static-3.4790",
  "tinymce-data": "static-1.40536",
  "tinymce-plugins": "static-1.57565",
  "ui-addon-sales-email": "static-1.5241",
  "onboarding-scopes": "static-1.6491",
  "ui-addon-opt": "static-4.8394",
  "apollo-link-hub-http": "static-2.4682",
  "hubspot-apollo-cache": "static-1.368",
  "react-window": "static-1.13",
  "ts-utils-lib": "static-1.202",
  "purchase-motions-api": "static-1.5976",
  "bend-plugin-pulse": "static-1.114",
  "event-emitter": "static-1.978",
  "fast-json-patch": "static-1.63",
  "onboarding-data-sync-lib": "static-1.2003",
  "growth-onboarding-next-action-components": "static-1.2031",
  "user-context-client": "static-1.4642",
  "idb-keyval": "static-1.44",
  "magpie-types": "static-1.5031",
  "nest": "static-1.260",
  "reactive-lib": "static-1.753",
  "simple-logging-lib": "static-1.3081",
  "unified-auth-core-lib": "static-1.810",
  "getting-started-shared-tasks-store": "static-1.17647",
  "markdown-it": "static-1.6",
  "integrations-error-boundary-lib": "static-1.13666",
  "integrations-tracking-lib": "static-1.5633",
  "native-integrations-shared-strings": "static-1.7812",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10396",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.528",
  "calling-error-reporting": "static-1.31340",
  "shared-worker-versioning": "static-1.11067",
  "calling-usage-tracker": "static-1.6571",
  "voice-sms-access-library": "static-1.1102",
  "customer-data-tracking": "static-1.6920",
  "commerce-permissions": "static-1.801",
  "products-iframe-lib": "static-1.8017",
  "products-ui-components-shared-msw-handlers": "static-1.10415",
  "location-customization-utils-lib": "static-1.9348",
  "apollo-dlb": "static-3.86",
  "immerable": "static-1.4184",
  "video-components-external": "static-1.11384",
  "video-data-lib": "static-1.35042",
  "data-agent-kit": "static-1.240",
  "feedback-loader": "static-1.29350",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10116",
  "fsm": "static-1.3762",
  "policy-lib": "static-1.6808",
  "react-colorpicker": "static-2.10238",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10179",
  "FileManagerLib": "static-1.39341",
  "NamespacedHubStyle": "static-2.9082",
  "FileManagerCore": "static-1.39200",
  "codemirror": "static-5.95",
  "content-assistance-lib": "static-1.7796",
  "layout-dnd-components": "static-1.12499",
  "layout-dnd-utils": "static-1.11474",
  "react-codemirror": "static-1.10656",
  "ui-addon-emoji-picker": "static-1.9918",
  "ui-brand-identity-lib": "static-1.15407",
  "InboxConnectUtils": "static-4.14895",
  "meetings-connect-utils-lib": "static-1.7635",
  "universal-page-editor-lib": "static-1.3044",
  "google-sheets-integration-lib": "static-1.324",
  "microsoft-drive-integration-lib": "static-1.449",
  "slack-ui-library": "static-1.10423",
  "calling-orchestration-schema": "static-1.35879",
  "sales-views-client-types": "static-1.4289",
  "crm-record-cards-service-types": "static-1.3615",
  "content-media-composition-data-lib": "static-1.12428",
  "content-media-compositions": "static-2.16435",
  "media-bridge-lib": "static-1.18976",
  "trellis-story-utils": "static-1.4545",
  "storybook-react": "static-1.33",
  "audio-components": "static-1.5960",
  "FileManagerImages": "static-1.36852",
  "video-components": "static-1.13387",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4567",
  "video-embed": "static-1.35876",
  "diff-match-patch": "static-1.7",
  "ui-addon-video-player": "static-1.8733",
  "ui-coaching-tips": "static-1.28641",
  "ContentData": "static-1.68526",
  "layout-data-lib": "static-1.9799",
  "browser-eslint": "static-2.57",
  "social-insights-client-types": "static-1.22192",
  "outpost": "static-1.4209",
  "growth-onboarding-feedback-components": "static-1.6610",
  "advanced-menus-core": "static-1.15174",
  "advanced-menus-lib": "static-1.12112",
  "ExportDialog": "static-6.10415",
  "ui-memberships-settings-lib": "static-1.34126",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15173",
  "simple-menus-lib": "static-1.16690"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.34591",
  "atom": "/atom/static-1.5104",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2528",
  "client-types": "/client-types/static-1.469",
  "cssUtils": "/cssUtils/static-1.798",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39902",
  "customer-data-objects": "/customer-data-objects/static-1.7703",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8121",
  "documents-lib": "/documents-lib/static-1.34596",
  "emoji-mart": "/emoji-mart/static-3.4",
  "flux-actions": "/flux-actions/static-1.341",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85933",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4749",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2166",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.5007",
  "highcharts": "/highcharts/static-8.104",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5621",
  "hs-test-utils": "/hs-test-utils/static-1.8045",
  "hub-http": "/hub-http/static-1.6253",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "HubStyle": "/HubStyle/static-2.11810",
  "HubStyleTokens": "/HubStyleTokens/static-2.11503",
  "I18n": "/I18n/static-7-hdineen_hubspot-i18n-react-compiler.2",
  "icons": "/icons/static-2.650",
  "jasmine-immutable": "/jasmine-immutable/static-1.3051",
  "jasmine-runner": "/jasmine-runner/static-1.6494",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.7186",
  "lodash": "/lodash/static-1.3",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "property-translator": "/property-translator/static-1.5429",
  "quartz": "/quartz/static-1.7068",
  "react": "/react/static-7.186",
  "react-dlb": "/react-dlb/static-1.79",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.71",
  "react-rhumb": "/react-rhumb/static-1.16704",
  "react-select-plus": "/react-select-plus/static-1.105",
  "react-utils": "/react-utils/static-2.5368",
  "react-virtualized": "/react-virtualized/static-2.99",
  "reference-resolvers": "/reference-resolvers/static-1.8202",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8125",
  "reporting-data": "/reporting-data/static-1.67681",
  "reporting-reports": "/reporting-reports/static-1.67359",
  "reporting-snowflake": "/reporting-snowflake/static-1.56299",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.9614",
  "reporting-visualizations": "/reporting-visualizations/static-1.59757",
  "reselect": "/reselect/static-2.16",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.8973",
  "sanitize": "/sanitize/static-1.4506",
  "sanitize-text": "/sanitize-text/static-1.8173",
  "self-service-api": "/self-service-api/static-1.10278",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1778",
  "signup-constants": "/signup-constants/static-1.18900",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8083",
  "StyleGuideUI": "/StyleGuideUI/static-3.487",
  "superstore": "/superstore/static-1.4791",
  "tinymce": "/tinymce/static-6.5",
  "transmute": "/transmute/static-2.85",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4793",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11020",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11076",
  "ui-images": "/ui-images/static-2.1160",
  "UIComponents": "/UIComponents/static-3.8449",
  "usage-tracker": "/usage-tracker/static-1.7378",
  "usage-tracker-container": "/usage-tracker-container/static-1.7368",
  "usage-tracker-core": "/usage-tracker-core/static-1.7228",
  "viral-links-lib": "/viral-links-lib/static-1.7097",
  "webpack-env": "/webpack-env/static-1.54",
  "data-fetching-client": "/data-fetching-client/static-1.9697",
  "foundations-components": "/foundations-components/static-1.7993",
  "immutable": "/immutable/static-2.79",
  "isMobile": "/isMobile/static-1.7",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "quartz-config": "/quartz-config/static-1.846",
  "quartz-core": "/quartz-core/static-1.6287",
  "quick-fetch": "/quick-fetch/static-1.3940",
  "raven": "/raven/static-3.5925",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "rpc-client-utils": "/rpc-client-utils/static-1.4683",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11179",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18040",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "metrics-js": "/metrics-js/static-1.9637",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3423",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3345",
  "quartz-webpack": "/quartz-webpack/static-1.3292",
  "foundations-assets": "/foundations-assets/static-1.4899",
  "foundations-theming": "/foundations-theming/static-1.4450",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10033",
  "hubspotter-http": "/hubspotter-http/static-1.4675",
  "sassPrefix": "/sassPrefix/static-1.156",
  "events-data-lib": "/events-data-lib/static-1.255",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7278",
  "crm-message-bus": "/crm-message-bus/static-1.43043",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.22337",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13059",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13197",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9856",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4029",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6821",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6916",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3610",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3870",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1010",
  "onboarding-tours": "/onboarding-tours/static-1.16669",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13766",
  "ui-addon-teams": "/ui-addon-teams/static-1.21598",
  "quartz-auth": "/quartz-auth/static-1.743",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9086",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5064",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9045",
  "ContentUtils": "/ContentUtils/static-1.68451",
  "customer-data-properties": "/customer-data-properties/static-1.51668",
  "forms-ai-lib": "/forms-ai-lib/static-1.4362",
  "forms-utils-lib": "/forms-utils-lib/static-1.12639",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5476",
  "react-dnd-compat": "/react-dnd-compat/static-1.4645",
  "react-tinymce": "/react-tinymce/static-1.55325",
  "tinymce-config": "/tinymce-config/static-2.54451",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10381",
  "underscore": "/underscore/static-1.8",
  "foundations-theming-base": "/foundations-theming-base/static-1.3435",
  "HeadJS": "/HeadJS/static-2.764",
  "framer-motion": "/framer-motion/static-1.72",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3156",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.152",
  "hs-locale-management": "/hs-locale-management/static-1.104",
  "ui-fonts": "/ui-fonts/static-1.765",
  "i18n-data": "/i18n-data/static-1.221",
  "moment-timezone": "/moment-timezone/static-5.83",
  "jasmine": "/jasmine/static-4.4357",
  "csstype": "/csstype/static-1.50",
  "quartz-head": "/quartz-head/static-1.733",
  "web-vitals": "/web-vitals/static-1.6",
  "batch-promise": "/batch-promise/static-1.1572",
  "external-options-client-types": "/external-options-client-types/static-1.4183",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "quartz-i18n": "/quartz-i18n/static-1.743",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7957",
  "graphql": "/graphql/static-1.82",
  "immer": "/immer/static-1.33",
  "persist-promise": "/persist-promise/static-1.3729",
  "reporting-client-types": "/reporting-client-types/static-1.2506",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.86",
  "growth-payments-core": "/growth-payments-core/static-1.25461",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4909",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1018",
  "merchandise-lib": "/merchandise-lib/static-1.264",
  "quartz-routing": "/quartz-routing/static-1.498",
  "hs-story-utils": "/hs-story-utils/static-1.9454",
  "react-flip-move": "/react-flip-move/static-1.70",
  "nested-table": "/nested-table/static-1.257",
  "timezone-utils": "/timezone-utils/static-2.5275",
  "seat-types-lib": "/seat-types-lib/static-1.79",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4262",
  "floating-ui": "/floating-ui/static-1.56",
  "react-aria": "/react-aria/static-1.66",
  "react-create-root-preference": "/react-create-root-preference/static-1.29",
  "tanstack-table": "/tanstack-table/static-1.55",
  "trellis-assets": "/trellis-assets/static-1.2035",
  "dispatcher": "/dispatcher/static-1.137",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.838",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.538",
  "module-federation": "/module-federation/static-1.23",
  "quartz-test": "/quartz-test/static-1.743",
  "quartz-tracking": "/quartz-tracking/static-1.447",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.93",
  "chirp-fetch": "/chirp-fetch/static-1.1918",
  "purchase-motions-components": "/purchase-motions-components/static-1.5973",
  "salesImages": "/salesImages/static-1.525",
  "ts-schema": "/ts-schema/static-1.4104",
  "bender-build-tools": "/bender-build-tools/static-1.3227",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2933",
  "stylex": "/stylex/static-1.33",
  "hs-resources": "/hs-resources/static-1.187",
  "pulse": "/pulse/static-1.611",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.978",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3821",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4163",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.35",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3715",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18529",
  "growth-data-modal": "/growth-data-modal/static-1.5473",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3097",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2003",
  "navigation-components": "/navigation-components/static-1.18115",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4883",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.735",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10202",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7583",
  "ui-universal-auth": "/ui-universal-auth/static-1.9014",
  "user-context": "/user-context/static-1.5136",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10031",
  "magpie-lib": "/magpie-lib/static-1.5571",
  "navigation-messaging": "/navigation-messaging/static-1.7442",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "chatspot-core": "/chatspot-core/static-1.21415",
  "copilot-toolkit": "/copilot-toolkit/static-1.11208",
  "cms-field-types": "/cms-field-types/static-1.4843",
  "content-icons-ui": "/content-icons-ui/static-1.2233",
  "integrations-lib": "/integrations-lib/static-1.16251",
  "calling-global-api": "/calling-global-api/static-1.64613",
  "calling-internal-common": "/calling-internal-common/static-1.31333",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65995",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58289",
  "commerce-products-lib": "/commerce-products-lib/static-1.9672",
  "crm-links": "/crm-links/static-1.6326",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9360",
  "file-manager-components": "/file-manager-components/static-1.23701",
  "google-libphonenumber": "/google-libphonenumber/static-1.38",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4247",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.662",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48841",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3989",
  "property-value-citations": "/property-value-citations/static-1.2282",
  "smart-property-lib": "/smart-property-lib/static-1.7237",
  "tiered-pricing": "/tiered-pricing/static-1.1282",
  "zustand": "/zustand/static-1.74",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9091",
  "final-form": "/final-form/static-1.70",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.19882",
  "tinymce-themes": "/tinymce-themes/static-1.56421",
  "data-token-picker": "/data-token-picker/static-1.16457",
  "hub-http-contrib": "/hub-http-contrib/static-1.3072",
  "interframe": "/interframe/static-3.4790",
  "tinymce-data": "/tinymce-data/static-1.40536",
  "tinymce-plugins": "/tinymce-plugins/static-1.57565",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5241",
  "onboarding-scopes": "/onboarding-scopes/static-1.6491",
  "ui-addon-opt": "/ui-addon-opt/static-4.8394",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4682",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.368",
  "react-window": "/react-window/static-1.13",
  "ts-utils-lib": "/ts-utils-lib/static-1.202",
  "purchase-motions-api": "/purchase-motions-api/static-1.5976",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.114",
  "event-emitter": "/event-emitter/static-1.978",
  "fast-json-patch": "/fast-json-patch/static-1.63",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2003",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2031",
  "user-context-client": "/user-context-client/static-1.4642",
  "idb-keyval": "/idb-keyval/static-1.44",
  "magpie-types": "/magpie-types/static-1.5031",
  "nest": "/nest/static-1.260",
  "reactive-lib": "/reactive-lib/static-1.753",
  "simple-logging-lib": "/simple-logging-lib/static-1.3081",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.810",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17647",
  "markdown-it": "/markdown-it/static-1.6",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13666",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5633",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7812",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10396",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.528",
  "calling-error-reporting": "/calling-error-reporting/static-1.31340",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11067",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6571",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1102",
  "customer-data-tracking": "/customer-data-tracking/static-1.6920",
  "commerce-permissions": "/commerce-permissions/static-1.801",
  "products-iframe-lib": "/products-iframe-lib/static-1.8017",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10415",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9348",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "immerable": "/immerable/static-1.4184",
  "video-components-external": "/video-components-external/static-1.11384",
  "video-data-lib": "/video-data-lib/static-1.35042",
  "data-agent-kit": "/data-agent-kit/static-1.240",
  "feedback-loader": "/feedback-loader/static-1.29350",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10116",
  "fsm": "/fsm/static-1.3762",
  "policy-lib": "/policy-lib/static-1.6808",
  "react-colorpicker": "/react-colorpicker/static-2.10238",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10179",
  "FileManagerLib": "/FileManagerLib/static-1.39341",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9082",
  "FileManagerCore": "/FileManagerCore/static-1.39200",
  "codemirror": "/codemirror/static-5.95",
  "content-assistance-lib": "/content-assistance-lib/static-1.7796",
  "layout-dnd-components": "/layout-dnd-components/static-1.12499",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11474",
  "react-codemirror": "/react-codemirror/static-1.10656",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9918",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15407",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14895",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7635",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3044",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.324",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.449",
  "slack-ui-library": "/slack-ui-library/static-1.10423",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35879",
  "sales-views-client-types": "/sales-views-client-types/static-1.4289",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3615",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12428",
  "content-media-compositions": "/content-media-compositions/static-2.16435",
  "media-bridge-lib": "/media-bridge-lib/static-1.18976",
  "trellis-story-utils": "/trellis-story-utils/static-1.4545",
  "storybook-react": "/storybook-react/static-1.33",
  "audio-components": "/audio-components/static-1.5960",
  "FileManagerImages": "/FileManagerImages/static-1.36852",
  "video-components": "/video-components/static-1.13387",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4567",
  "video-embed": "/video-embed/static-1.35876",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8733",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28641",
  "ContentData": "/ContentData/static-1.68526",
  "layout-data-lib": "/layout-data-lib/static-1.9799",
  "browser-eslint": "/browser-eslint/static-2.57",
  "social-insights-client-types": "/social-insights-client-types/static-1.22192",
  "outpost": "/outpost/static-1.4209",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6610",
  "advanced-menus-core": "/advanced-menus-core/static-1.15174",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12112",
  "ExportDialog": "/ExportDialog/static-6.10415",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34126",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15173",
  "simple-menus-lib": "/simple-menus-lib/static-1.16690"
}
};
